import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'
import { QuotationStatus } from 'components/ordering/quotation/api/dtos/quotation-status.js'

type IQuotationUserDTO = {
  email_address: string
  user_id: number
}

export type IQuotationSummaryDTO = {
  statuses: QuotationStatus[]
  users: IQuotationUserDTO[]
}

export class QuotationSummaryDTO {
  statuses: QuotationStatus[]
  users: { emailAddress: string, userId: number }[]

  constructor(data: IQuotationSummaryDTO) {
    this.statuses = data.statuses
    this.users = data.users.map(mapUser)
  }
}

const mapUser = ({ email_address, user_id }: IQuotationUserDTO) =>
  ({ emailAddress: email_address, userId: user_id })

const validate = createValidate<IQuotationSummaryDTO>()

export const parseQuotationSummaryDTO = (data: unknown): QuotationSummaryDTO => {
  validateGuard(validate, data, 'quotation summary')
  return new QuotationSummaryDTO(data)
}
